import React from 'react';
import Search from './Search';
import RoleInfoTab from './roleInfo/RoleInfoTab';
import RoleUsersTab from './roleUsers/RoleUsersTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class RoleSetup extends React.Component {
    render() {
        let opts = {
            title: "Role Setup",
            description: "Create, modify, and remove roles",
            addPrivilege: App.hasPrivilege("AdminRoleSetupAdd"),
			addNewTitle: "Add new role",
            helpKey: Help.roleSetupHelpKey,
            recentType: "role",
            list: {
                url: API.Security.url('/roleSetup/search'),
                rowKey: "roleId",
                columns: [
                    { key: 'roleName', name: 'Role Name', sortable: true, width: 300 },
                    { key: 'roleDescription', name: 'Role Description', sortable: false },
                    { key: 'userTypeDescription', name: 'User Type', sortable: false },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "roleInfo", title: "Role Info", helpKey: Help.roleSetupInfoHelpKey, comp: RoleInfoTab },
                { key: "roleUsers", title: "Role Users", helpKey: Help.roleSetupUsersHelpKey, comp: RoleUsersTab },
                { key: "roleAudit", title: "Audit Info", helpKey: Help.roleSetupAuditHelpKey, comp: AuditInfoTab }
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default RoleSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/RoleSetup.js